export default {
  contained: {
    boxShadow: 'none!important',
    backgroundColor: '#FFFFFF',
  },
};
